import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ed751dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "job-detail" }
const _hoisted_2 = {
  key: 0,
  class: "job-content"
}
const _hoisted_3 = { class: "job-body" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 通告單 ")
const _hoisted_7 = { class: "tracking-number" }
const _hoisted_8 = { class: "outline" }
const _hoisted_9 = { class: "tags" }
const _hoisted_10 = {
  key: 0,
  class: "job-category-tag --bg-blue"
}
const _hoisted_11 = {
  key: 1,
  class: "job-category-tag --bg-purple"
}
const _hoisted_12 = {
  key: 2,
  class: "job-category-tag --bg-pink"
}
const _hoisted_13 = {
  key: 3,
  class: "job-category-tag --bg-green"
}
const _hoisted_14 = {
  class: "attr",
  style: {"margin-bottom":"0"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "attr__title",
  style: {"line-height":"1"}
}, "名稱：", -1))
const _hoisted_16 = {
  class: "attr__content",
  style: {"font-size":"14px"}
}
const _hoisted_17 = {
  key: 0,
  class: "attr attr--inline"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "報名截止時間：", -1))
const _hoisted_19 = {
  class: "attr__content",
  style: {"color":"#d80101"}
}
const _hoisted_20 = {
  key: 1,
  class: "attr attr--inline"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "attr__title" }, "基本薪(單人)：", -1))
const _hoisted_22 = {
  class: "attr__content",
  style: {"font-weight":"bold","font-size":"14px"}
}
const _hoisted_23 = {
  key: 2,
  class: "attr"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "必要條件：", -1))
const _hoisted_25 = { class: "demands" }
const _hoisted_26 = { class: "demand__item" }
const _hoisted_27 = {
  key: 3,
  class: "attr"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "額外達標：", -1))
const _hoisted_29 = { class: "demands" }
const _hoisted_30 = { class: "demand__item" }
const _hoisted_31 = { class: "demand__reward" }
const _hoisted_32 = {
  key: 4,
  class: "attr attr--inline"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "需求人數：", -1))
const _hoisted_34 = {
  class: "attr__content",
  style: {"font-weight":"bold"}
}
const _hoisted_35 = {
  key: 5,
  class: "attr attr--inline salary"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "本次預計薪資：", -1))
const _hoisted_37 = {
  class: "attr__content",
  style: {"font-weight":"bold"}
}
const _hoisted_38 = {
  key: 6,
  class: "attr attr--inline salary"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "本次薪資：", -1))
const _hoisted_40 = {
  class: "attr__content",
  style: {"font-weight":"bold"}
}
const _hoisted_41 = {
  key: 7,
  class: "attr"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "時間：", -1))
const _hoisted_43 = { class: "attr__content" }
const _hoisted_44 = { class: "time-info" }
const _hoisted_45 = { class: "periods" }
const _hoisted_46 = { style: {"font-weight":"bold","margin-right":"10px"} }
const _hoisted_47 = { style: {"font-weight":"bold","margin-right":"10px"} }
const _hoisted_48 = { style: {"font-weight":"bold","margin-right":"10px"} }
const _hoisted_49 = {
  key: 2,
  class: "period-total-number"
}
const _hoisted_50 = /*#__PURE__*/_createTextVNode("共計 ")
const _hoisted_51 = {
  key: 8,
  class: "attr"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "地點：", -1))
const _hoisted_53 = {
  class: "attr__content",
  style: {"word-break":"break-all"}
}
const _hoisted_54 = {
  key: 9,
  class: "attr"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "最後發文時間：", -1))
const _hoisted_56 = {
  class: "attr__content",
  style: {"font-weight":"bold"}
}
const _hoisted_57 = { class: "attrs-inline" }
const _hoisted_58 = {
  key: 0,
  class: "attr"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "圖片：", -1))
const _hoisted_60 = { class: "attr__content attr__content--seperate" }
const _hoisted_61 = { style: {"font-weight":"bold"} }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  key: 1,
  class: "attr"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "廠商提供廣告品日期：", -1))
const _hoisted_65 = { class: "attr__content" }
const _hoisted_66 = { class: "attr" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "其他備註：", -1))
const _hoisted_68 = { class: "attr__content" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = {
  class: "attr",
  style: {"flex-grow":"1"}
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "attr__title" }, "時間：", -1))
const _hoisted_72 = { class: "times" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "時間"),
    /*#__PURE__*/_createElementVNode("th", null, "時數"),
    /*#__PURE__*/_createElementVNode("th", null, "報到時間"),
    /*#__PURE__*/_createElementVNode("th", null, "備註")
  ])
], -1))
const _hoisted_74 = { class: "is-registered" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode("已報到")
const _hoisted_76 = /*#__PURE__*/_createTextVNode("未報到")
const _hoisted_77 = {
  key: 1,
  class: "job-foot"
}
const _hoisted_78 = /*#__PURE__*/_createTextVNode("聯絡官方")
const _hoisted_79 = /*#__PURE__*/_createTextVNode("關閉")
const _hoisted_80 = {
  key: 2,
  class: "job-foot"
}
const _hoisted_81 = /*#__PURE__*/_createTextVNode("聯絡官方")
const _hoisted_82 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_83 = /*#__PURE__*/_createTextVNode("我要報名")
const _hoisted_84 = /*#__PURE__*/_createTextVNode("已報名")
const _hoisted_85 = {
  key: 1,
  class: "job-content"
}
const _hoisted_86 = { class: "job-body" }
const _hoisted_87 = { class: "confirm" }
const _hoisted_88 = { class: "confirm-head" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirm-text" }, "通告名稱：", -1))
const _hoisted_90 = { class: "confirm-title" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-foot" }, "是否確認報名？", -1))
const _hoisted_92 = { class: "job-foot job-foot--confirm" }
const _hoisted_93 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_94 = /*#__PURE__*/_createTextVNode("我要報名")
const _hoisted_95 = {
  key: 2,
  class: "job-loading"
}
const _hoisted_96 = {
  key: 3,
  class: "job-tag job-tag--yellow"
}
const _hoisted_97 = {
  key: 4,
  class: "job-tag"
}
const _hoisted_98 = {
  key: 5,
  class: "job-tag job-tag--orange"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isReady && _ctx.currentStep === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.jobDetail.trackingNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.jobDetail.jobType === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 實體活動 "))
                    : _createCommentVNode("", true),
                  (_ctx.jobDetail.jobType === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 業配 "))
                    : _createCommentVNode("", true),
                  (_ctx.jobDetail.priceType === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 收費 "))
                    : _createCommentVNode("", true),
                  (_ctx.jobDetail.priceType === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 互惠 "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.jobDetail.name), 1)
                ])
              ]),
              (!_ctx.isPersonal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.jobDetail.humanDeadline()), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.jobDetail.priceType === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.jobDetail.recruitUnitPrice.toLocaleString()), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.jobDetail.requiredCondtions().length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("ul", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobDetail.requiredCondtions(), (condition, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "demand",
                          key: index
                        }, [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(condition.text), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.jobDetail.additionalCondtions().length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("ul", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobDetail.additionalCondtions(), (condition, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "demand",
                          key: index
                        }, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(condition.text), 1),
                          _createElementVNode("span", _hoisted_31, "+" + _toDisplayString(condition.price.toLocaleString()), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isPersonal || [1].includes(_ctx.personalJobType))
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.jobDetail.recruitDemands.toLocaleString()) + " 位 ", 1)
                  ]))
                : _createCommentVNode("", true),
              ([2, 3].includes(_ctx.personalJobType))
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.jobDetail.myPay), 1)
                  ]))
                : _createCommentVNode("", true),
              ([4].includes(_ctx.personalJobType))
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.jobDetail.myPay), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.jobDetail.jobType === 1 && ![3, 4].includes(_ctx.personalJobType))
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobDetail.periods(), (period, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "period",
                              key: index
                            }, [
                              (period.fromDate === period.toDate)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("span", _hoisted_46, _toDisplayString(period.fromDate), 1),
                                    _createElementVNode("span", null, _toDisplayString(period.fromTime) + " ~ " + _toDisplayString(period.toTime), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("span", _hoisted_47, _toDisplayString(period.fromDate), 1),
                                    _createElementVNode("span", null, _toDisplayString(period.fromTime) + " ~ ", 1),
                                    _createElementVNode("span", _hoisted_48, _toDisplayString(period.toDate), 1),
                                    _createElementVNode("span", null, _toDisplayString(period.toTime), 1)
                                  ], 64)),
                              (index === _ctx.jobDetail.periods().length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                                    _hoisted_50,
                                    _createElementVNode("b", null, _toDisplayString(_ctx.jobDetail.totalPeriodsHrs()) + " H", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.jobDetail.jobType === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.jobDetail.location() || "-"), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.jobDetail.humanAdsInfo.postDeadline)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.jobDetail.humanAdsInfo.postDeadline), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_57, [
                (_ctx.jobDetail.humanAdsInfo.postPicTypes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.jobDetail.humanAdsInfo.postPicTypes), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.jobDetail.humanAdsInfo.postPicNumber) + "張", 1),
                        (_ctx.jobDetail.humanAdsInfo.postPicIncludeText)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_62, "(包含廠商提供文字)"))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.jobDetail.humanAdsInfo.adDeadline)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.jobDetail.humanAdsInfo.adDeadline), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.jobDetail.note || "-"), 1)
              ])
            ])
          ]),
          ([3, 4].includes(_ctx.personalJobType) && _ctx.jobDetail.shifts.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("table", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobDetail.shifts, (shift, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(shift.period), 1),
                          _createElementVNode("td", null, _toDisplayString(shift.duration) + " H", 1),
                          _createElementVNode("td", null, _toDisplayString(shift.registerAt), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_74, [
                              (shift.isRegisterd)
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 0,
                                    color: "#33cc99"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_75
                                    ]),
                                    _: 1
                                  }))
                                : (shift.isAfterStart)
                                  ? (_openBlock(), _createBlock(_component_a_tag, {
                                      key: 1,
                                      color: "#a1a1a1"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_76
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPersonal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                ([2, 3].includes(_ctx.personalJobType))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "contact-btn",
                      onClick: _ctx.contact
                    }, {
                      default: _withCtx(() => [
                        _hoisted_78
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_button, {
                  class: "close-btn close-btn--center",
                  onClick: _ctx.close
                }, {
                  default: _withCtx(() => [
                    _hoisted_79
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _createVNode(_component_a_button, {
                  class: "contact-btn",
                  onClick: _ctx.contact
                }, {
                  default: _withCtx(() => [
                    _hoisted_81
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  class: "close-btn",
                  onClick: _ctx.close
                }, {
                  default: _withCtx(() => [
                    _hoisted_82
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (!_ctx.jobDetail.isRegistered)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "register-btn",
                      type: "primary",
                      onClick: _ctx.toConfirm
                    }, {
                      default: _withCtx(() => [
                        _hoisted_83
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      class: "register-btn",
                      type: "primary",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_84
                      ]),
                      _: 1
                    }))
              ]))
        ]))
      : (_ctx.isReady && _ctx.currentStep === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _hoisted_89,
                  _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.jobDetail.name), 1)
                ]),
                _hoisted_91
              ])
            ]),
            _createElementVNode("div", _hoisted_92, [
              _createVNode(_component_a_button, {
                class: "close-btn",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [
                  _hoisted_93
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                class: "register-btn",
                type: "primary",
                onClick: _ctx.register
              }, {
                default: _withCtx(() => [
                  _hoisted_94
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_95, [
            _createVNode(_component_loading_outlined)
          ])),
    (_ctx.personalJobType === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_96, " 審核中 "))
      : _createCommentVNode("", true),
    (_ctx.personalJobType === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_97, "報名成功"))
      : _createCommentVNode("", true),
    (_ctx.personalJobType === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_98, " 本日通告 "))
      : _createCommentVNode("", true)
  ]))
}